"use strict";

// Local components
import Vue from 'vue'
import App from './App'
import Devices from './components/Devices.vue'
import SideBar from './components/SideBar.vue'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import Query from './components/Query.vue'
import DeviceProperties from './components/DeviceProperties.vue'
import Device from './components/Device.vue'
import QuerySelection from './components/QuerySelection.vue'
import Index from './components/Index.vue'
import Error from './components/Error.vue'
import RealTime from './components/RealtimeGraph.vue'
import Login from './components/Login.vue'
import Preferences from './components/Preferences.vue'
import Email from './components/Email.vue'

// Router
import VueRouter from 'vue-router'
// ElementUI library
import ElementUI from 'element-ui'
// Language library (change /lang/en to change language)
import locale from 'element-ui/lib/locale/lang/en'
// Charts, Maps and Drilldown in case needed (boost too to optimize performance)
import Highcharts from 'highcharts';
import HighMaps from '../node_modules/highcharts/highmaps.js'
import VueHighcharts from 'vue-highcharts'
import loadMap from 'highcharts/modules/map';
import loadDrilldown from 'highcharts/modules/drilldown';
import boost from 'highcharts/modules/boost'
import VueCookie from 'vue-cookie'
// Base css provided with the library (Element)
import '../node_modules/element-ui/lib/theme-chalk/index.css'

loadMap(Highcharts);
loadDrilldown(Highcharts);
boost(Highcharts);

Vue.config.productionTip = false

Vue.use(VueCookie);
Vue.use(ElementUI, {locale});
Vue.use(VueRouter);
Vue.use(VueHighcharts, {Highcharts });
Vue.use(HighMaps);

// This is a global component declaration
Vue.component('app-oven', Devices);
Vue.component('app-sidebar', SideBar);
Vue.component('app-header', Header);
Vue.component('app-footer', Footer);
Vue.component('app-query', Query);
Vue.component('app-deviceproperties', DeviceProperties);
Vue.component('app-device', Device)
Vue.component('app-queryselection', QuerySelection)
Vue.component('app-index', Index)
Vue.component('app-error', Error)
Vue.component('app-realtime', RealTime);
Vue.component('app-login', Login)
Vue.component('app-preferences', Preferences)
Vue.component('app-email', Email)

const routes = [
  { path: '/index', component: Index},
  { path: '/', component: Login},
  { path: '/device/:deviceId', component: Device},
  { path: '/preferences', component: Preferences},
  { path: '*', component: Error}
];

const router = new VueRouter({
  routes: routes,
  mode: "history" // Gets rid of the # before the path
})

new Vue({
  el: '#app',
  router: router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js